// ═══ DACEWAV.STORE — Config ═══
export const FC = {
  apiKey: 'AIzaSyCr2dekkLLifIg0_JlLfEleaV32b5XdvIQ',
  authDomain: 'dacewav-store-3b0f5.firebaseapp.com',
  databaseURL: 'https://dacewav-store-3b0f5-default-rtdb.firebaseio.com',
  projectId: 'dacewav-store-3b0f5',
  storageBucket: 'dacewav-store-3b0f5.firebasestorage.app',
  messagingSenderId: '163354805352',
  appId: '1:163354805352:web:d8a99d1d71323de1ed27dd',
};

export const DACE_VER = '5.2.0';

export const ANIMS = [
  'none',
  'flotar', 'deslizar-arriba', 'deslizar-abajo', 'deslizar-izq', 'deslizar-der',
  'rebotar', 'sacudida', 'temblor', 'balanceo', 'drift',
  'rotar', 'spin-lento', 'spin-rapido', 'wobble',
  'pulsar', 'parpadeo', 'fade-in', 'respirar', 'latido',
  'zoom-in', 'zoom-out', 'pop', 'rubber-band', 'jello',
  'cambio-color', 'brillo', 'neon-flicker', 'glitch', 'holograma',
  'typing', 'shake-x', 'heartbeat', 'flip', 'swing',
  'tada', 'bounce-in', 'elastic', 'slide-up-fade',
];
